webpackJsonp([93],{

/***/ 10:
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./en/hotel.json": [
		115,
		10
	],
	"./ja/hotel.json": [
		116,
		9
	],
	"./ko/hotel.json": [
		117,
		8
	],
	"./zh-CN/hotel.json": [
		118,
		7
	],
	"./zh-TW/hotel.json": [
		119,
		6
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
module.exports = webpackAsyncContext;
webpackAsyncContext.id = 10;

/***/ }),

/***/ 138:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 139:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 140:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 16:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 18:
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./al": [
		31,
		78
	],
	"./al.js": [
		31,
		78
	],
	"./ar": [
		32,
		77
	],
	"./ar.js": [
		32,
		77
	],
	"./bg": [
		33,
		76
	],
	"./bg.js": [
		33,
		76
	],
	"./ca": [
		34,
		75
	],
	"./ca.js": [
		34,
		75
	],
	"./cs": [
		36,
		73
	],
	"./cs.extra": [
		35,
		74
	],
	"./cs.extra.js": [
		35,
		74
	],
	"./cs.js": [
		36,
		73
	],
	"./da": [
		37,
		72
	],
	"./da.js": [
		37,
		72
	],
	"./de": [
		39,
		70
	],
	"./de.extra": [
		38,
		71
	],
	"./de.extra.js": [
		38,
		71
	],
	"./de.js": [
		39,
		70
	],
	"./el": [
		41,
		68
	],
	"./el.extra": [
		40,
		69
	],
	"./el.extra.js": [
		40,
		69
	],
	"./el.js": [
		41,
		68
	],
	"./en": [
		43,
		66
	],
	"./en.extra": [
		42,
		67
	],
	"./en.extra.js": [
		42,
		67
	],
	"./en.js": [
		43,
		66
	],
	"./es": [
		44,
		65
	],
	"./es.js": [
		44,
		65
	],
	"./eu": [
		45,
		64
	],
	"./eu.js": [
		45,
		64
	],
	"./fa": [
		46,
		63
	],
	"./fa.js": [
		46,
		63
	],
	"./fi": [
		48,
		61
	],
	"./fi.extra": [
		47,
		62
	],
	"./fi.extra.js": [
		47,
		62
	],
	"./fi.js": [
		48,
		61
	],
	"./fr": [
		50,
		59
	],
	"./fr.extra": [
		49,
		60
	],
	"./fr.extra.js": [
		49,
		60
	],
	"./fr.js": [
		50,
		59
	],
	"./he": [
		52,
		57
	],
	"./he.extra": [
		51,
		58
	],
	"./he.extra.js": [
		51,
		58
	],
	"./he.js": [
		52,
		57
	],
	"./hr": [
		54,
		55
	],
	"./hr.extra": [
		53,
		56
	],
	"./hr.extra.js": [
		53,
		56
	],
	"./hr.js": [
		54,
		55
	],
	"./hu": [
		56,
		53
	],
	"./hu.extra": [
		55,
		54
	],
	"./hu.extra.js": [
		55,
		54
	],
	"./hu.js": [
		56,
		53
	],
	"./id": [
		58,
		51
	],
	"./id.extra": [
		57,
		52
	],
	"./id.extra.js": [
		57,
		52
	],
	"./id.js": [
		58,
		51
	],
	"./it": [
		60,
		49
	],
	"./it.extra": [
		59,
		50
	],
	"./it.extra.js": [
		59,
		50
	],
	"./it.js": [
		60,
		49
	],
	"./ja": [
		62,
		47
	],
	"./ja.extra": [
		61,
		48
	],
	"./ja.extra.js": [
		61,
		48
	],
	"./ja.js": [
		62,
		47
	],
	"./ko": [
		63,
		46
	],
	"./ko.js": [
		63,
		46
	],
	"./lt": [
		65,
		44
	],
	"./lt.extra": [
		64,
		45
	],
	"./lt.extra.js": [
		64,
		45
	],
	"./lt.js": [
		65,
		44
	],
	"./lv": [
		67,
		42
	],
	"./lv.extra": [
		66,
		43
	],
	"./lv.extra.js": [
		66,
		43
	],
	"./lv.js": [
		67,
		42
	],
	"./ms": [
		69,
		40
	],
	"./ms.extra": [
		68,
		41
	],
	"./ms.extra.js": [
		68,
		41
	],
	"./ms.js": [
		69,
		40
	],
	"./nl": [
		71,
		38
	],
	"./nl.extra": [
		70,
		39
	],
	"./nl.extra.js": [
		70,
		39
	],
	"./nl.js": [
		71,
		38
	],
	"./no": [
		72,
		37
	],
	"./no.js": [
		72,
		37
	],
	"./pl": [
		73,
		36
	],
	"./pl.js": [
		73,
		36
	],
	"./pt-br": [
		74,
		35
	],
	"./pt-br.js": [
		74,
		35
	],
	"./pt-pt": [
		75,
		34
	],
	"./pt-pt.js": [
		75,
		34
	],
	"./ro": [
		77,
		32
	],
	"./ro.extra": [
		76,
		33
	],
	"./ro.extra.js": [
		76,
		33
	],
	"./ro.js": [
		77,
		32
	],
	"./ru": [
		79,
		30
	],
	"./ru.extra": [
		78,
		31
	],
	"./ru.extra.js": [
		78,
		31
	],
	"./ru.js": [
		79,
		30
	],
	"./sk": [
		81,
		28
	],
	"./sk.extra": [
		80,
		29
	],
	"./sk.extra.js": [
		80,
		29
	],
	"./sk.js": [
		81,
		28
	],
	"./sl": [
		83,
		26
	],
	"./sl.extra": [
		82,
		27
	],
	"./sl.extra.js": [
		82,
		27
	],
	"./sl.js": [
		83,
		26
	],
	"./sq": [
		84,
		25
	],
	"./sq.js": [
		84,
		25
	],
	"./sr": [
		86,
		23
	],
	"./sr.extra": [
		85,
		24
	],
	"./sr.extra.js": [
		85,
		24
	],
	"./sr.js": [
		86,
		23
	],
	"./sv": [
		88,
		21
	],
	"./sv.extra": [
		87,
		22
	],
	"./sv.extra.js": [
		87,
		22
	],
	"./sv.js": [
		88,
		21
	],
	"./th": [
		89,
		20
	],
	"./th.js": [
		89,
		20
	],
	"./tr": [
		90,
		19
	],
	"./tr.js": [
		90,
		19
	],
	"./ua": [
		92,
		17
	],
	"./ua.extra": [
		91,
		18
	],
	"./ua.extra.js": [
		91,
		18
	],
	"./ua.js": [
		92,
		17
	],
	"./uk": [
		94,
		15
	],
	"./uk.extra": [
		93,
		16
	],
	"./uk.extra.js": [
		93,
		16
	],
	"./uk.js": [
		94,
		15
	],
	"./zh_cn": [
		96,
		13
	],
	"./zh_cn.extra": [
		95,
		14
	],
	"./zh_cn.extra.js": [
		95,
		14
	],
	"./zh_cn.js": [
		96,
		13
	],
	"./zh_tw": [
		97,
		12
	],
	"./zh_tw.js": [
		97,
		12
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
module.exports = webpackAsyncContext;
webpackAsyncContext.id = 18;

/***/ }),

/***/ 245:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(16);
__webpack_require__(139);
__webpack_require__(140);
__webpack_require__(138);

__webpack_require__(6);
__webpack_require__(5);

/***/ }),

/***/ 276:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($, jQuery) {

var init = function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var countryList, defaultCountry, App, OwlCarousel;
        return regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
                switch (_context.prev = _context.next) {
                    case 0:
                        _context.next = 2;
                        return __webpack_require__.e/* import() */(0/* duplicate */).then(__webpack_require__.bind(null, 8));

                    case 2:
                        _context.next = 4;
                        return __webpack_require__.e/* import() */(79).then(__webpack_require__.bind(null, 111));

                    case 4:
                        _context.next = 6;
                        return __webpack_require__.e/* import() */(3/* duplicate */).then(__webpack_require__.bind(null, 20));

                    case 6:
                        _context.next = 8;
                        return __webpack_require__.e/* import() */(1/* duplicate */).then(__webpack_require__.bind(null, 12));

                    case 8:
                        countryList = {};
                        defaultCountry = void 0;
                        _context.t0 = locale;
                        _context.next = _context.t0 === 'en' ? 13 : _context.t0 === 'ja' ? 18 : _context.t0 === 'zh-CN' ? 23 : _context.t0 === 'ko' ? 28 : 33;
                        break;

                    case 13:
                        _context.next = 15;
                        return __webpack_require__.e/* import() */(85).then(__webpack_require__.bind(null, 141));

                    case 15:
                        countryList = _context.sent;

                        defaultCountry = 'US';
                        return _context.abrupt('break', 37);

                    case 18:
                        _context.next = 20;
                        return __webpack_require__.e/* import() */(84).then(__webpack_require__.bind(null, 142));

                    case 20:
                        countryList = _context.sent;

                        defaultCountry = 'JP';
                        return _context.abrupt('break', 37);

                    case 23:
                        _context.next = 25;
                        return __webpack_require__.e/* import() */(82).then(__webpack_require__.bind(null, 144));

                    case 25:
                        countryList = _context.sent;

                        defaultCountry = 'CN';
                        return _context.abrupt('break', 37);

                    case 28:
                        _context.next = 30;
                        return __webpack_require__.e/* import() */(83).then(__webpack_require__.bind(null, 143));

                    case 30:
                        countryList = _context.sent;

                        defaultCountry = 'KO';
                        return _context.abrupt('break', 37);

                    case 33:
                        _context.next = 35;
                        return __webpack_require__.e/* import() */(81).then(__webpack_require__.bind(null, 145));

                    case 35:
                        countryList = _context.sent;

                        defaultCountry = 'TW';

                    case 37:
                        _context.next = 39;
                        return __webpack_require__.e/* import() */(4/* duplicate */).then(__webpack_require__.bind(null, 19));

                    case 39:
                        App = _context.sent;
                        _context.next = 42;
                        return __webpack_require__.e/* import() */(2/* duplicate */).then(__webpack_require__.bind(null, 11));

                    case 42:
                        OwlCarousel = _context.sent;

                        $(document).ready(function () {
                            App.init();
                            App.initParallaxBg();
                            OwlCarousel.initOwlCarousel();
                        });

                        (function ($) {
                            var countryList$ = $('#signup-country');
                            for (var country in countryList) {
                                if (country !== defaultCountry) {
                                    countryList$.append($('<option>', {
                                        value: country
                                    }).text(countryList[country]));
                                } else {
                                    countryList$.append($('<option>', {
                                        value: country,
                                        selected: true
                                    }).text(countryList[country]));
                                }
                            }
                        })(jQuery);

                    case 45:
                    case 'end':
                        return _context.stop();
                }
            }
        }, _callee, this);
    }));

    return function init() {
        return _ref.apply(this, arguments);
    };
}();

__webpack_require__(245);

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

init().then(_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
    var parsley, moment, text, validator;
    return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
            switch (_context2.prev = _context2.next) {
                case 0:
                    _context2.next = 2;
                    return __webpack_require__.e/* import() */(5/* duplicate */).then(__webpack_require__.bind(null, 23));

                case 2:
                    parsley = _context2.sent;
                    _context2.next = 5;
                    return __webpack_require__(18)("./" + locale.replace('-', '_').toLowerCase());

                case 5:
                    _context2.next = 7;
                    return __webpack_require__.e/* import() */(11).then(__webpack_require__.bind(null, 22));

                case 7:
                    moment = _context2.sent;
                    _context2.next = 10;
                    return __webpack_require__(10)("./" + locale + '/hotel.json');

                case 10:
                    text = _context2.sent;


                    $('#signup-username').attr('data-parsley-required', true);
                    $('#signup-password').attr({
                        'data-parsley-required': true,
                        'data-parsley-minlength': '8',
                        'data-parsley-pattern': '(^[0-9]+[A-Za-z]+|^[A-Za-z]+[0-9]+)[A-Za-z0-9]*',
                        'data-parsley-pattern-message': text.SystemText.AtLeast
                    });
                    $('#signup-repeat-password').attr({
                        'data-parsley-required': true,
                        'data-parsley-equalto': '#signup-password'
                    });
                    $('#signup-name').attr({
                        'data-parsley-required': true,
                        'data-parsley-minlength': 2,
                        'data-parsley-whitespace': 'trim'
                    });
                    $('input[name="gender"]').attr('data-parsley-required', function () {
                        return this.required;
                    });
                    $('#signup-id').attr('data-parsley-required', function () {
                        return this.required;
                    }).attr({
                        'data-parsley-type': 'alphanum',
                        'data-parsley-minlength': 7
                    });
                    $('#signup-country').attr('data-parsley-required', function () {
                        return this.required;
                    });
                    $('#signup-birthday-year').attr({
                        'data-parsley-required': true,
                        'data-parsley-range': '[1900, ' + moment().get('year') + ']',
                        'data-parsley-group': 'birthday'
                    });
                    $('#signup-birthday-month').attr({
                        'data-parsley-required': true,
                        'data-parsley-range': '[1, 12]',
                        'data-parsley-group': 'birthday'
                    });
                    $('#signup-birthday-day').attr({
                        'data-parsley-required': true,
                        'data-parsley-range': '[1, 31]'
                    });
                    $('#signup-phone').attr('data-parsley-required', function () {
                        return this.required;
                    }).attr({
                        'data-parsley-type': 'number'
                    });
                    $('#signup-cellphone').attr('data-parsley-required', function () {
                        return this.required;
                    }).attr({
                        'data-parsley-type': 'number'
                    });
                    $('#signup-thsr-cellphone').attr('data-parsley-required', function () {
                        return this.required;
                    }).attr({
                        'data-parsley-type': 'number',
                        'data-parsley-error-message': "如您加購高鐵聯票，手機號碼請勿超過10碼"
                    });
                    $('#signup-zip-code').attr('data-parsley-required', function () {
                        return this.required;
                    }).attr({
                        'data-parsley-type': 'number',
                        'data-parsley-length': '[3, 6]'
                    });
                    $('#signup-address').attr('data-parsley-required', function () {
                        return this.required;
                    });
                    $('#signup-email').attr({
                        'data-parsley-required': true,
                        'data-parsley-type': 'email'
                    });

                    validator = parsley.$element.find('#signup-form').parsley({
                        errorsWrapper: '<div></div>',
                        errorTemplate: '<span class="color-red"></span>',
                        errorsContainer: function errorsContainer(field) {
                            return field.$element.closest('td').find('div.error-message');
                        }
                    });


                    $('#signup-birthday-year, #signup-birthday-month').change(function () {
                        if (validator.isValid('birthday')) {
                            var year = $('#signup-birthday-year').val();
                            var month = $('#signup-birthday-month').val();
                            var validDay = moment().year(year).month(month - 1).endOf('month');
                            var isDST = validDay.isDST();
                            if (isDST === true) {
                                var offset = validDay.utcOffset();
                                if (offset < 0) {
                                    validDay.utcOffset(offset + 60);
                                } else {
                                    validDay.utcOffset(offset - 60);
                                }
                            }
                            $('#signup-birthday-day').attr('data-parsley-range', '[1, ' + validDay.date() + ']');
                        }
                    });

                    $('#signup-submit').click(function () {
                        validator.validate();

                        if (validator.isValid()) {
                            $('#signup-form').submit();
                        }
                    });

                    $('#signup-reset').click(function () {
                        validator.reset();
                    });

                case 31:
                case 'end':
                    return _context2.stop();
            }
        }
    }, _callee2, this);
})));
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1), __webpack_require__(1)))

/***/ }),

/***/ 5:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 6:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })

},[276]);


// WEBPACK FOOTER //
// js/build/signup-55fb15e5827d0458f059.js